// src/components/ClientCarousel.js
import React from 'react';
import './ClientCarousel.css';

function ClientCarousel() {
  const clients = [
    { name: 'Tata Motors', logo: '/images/tata-motors-logo.png' },
    { name: 'Trueview',    logo: '/images/trueview-logo.png' },
    { name: 'Guardwel',    logo: '/images/guardwel-logo.png' },
    { name: 'Elanpro',     logo: '/images/elanpro-logo.png' },
    { name: 'Terra91',     logo: '/images/terra91logo.png' },
    { name: 'Teakwood',     logo: '/images/teakwoodlogo.png' },
    { name: 'Samsung',     logo: '/images/samsunglogo.png' },
    { name: 'VIP',     logo: '/images/viplogo.png' },
  ];

  // Duplicate once to enable a seamless loop (animate half the track)
  const strip = [...clients, ...clients];

  return (
    <div className="carousel-container">
      <h2>Our Clients</h2>
      <div className="carousel" aria-label="Client logos">
        <div className="carousel-track">
          {strip.map((client, i) => (
            <div key={`${client.name}-${i}`} className="carousel-item">
              <img
                src={`${process.env.PUBLIC_URL}${client.logo}`}
                alt={client.name}
                className="client-logo"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ClientCarousel;
